import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { PedidoRelatorioElement } from '../../interfaces/pedido.relatorio';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';
import { Router } from '@angular/router';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-fechar-comissao',
  templateUrl: './fechar-comissao.component.html',
  styleUrls: ['./fechar-comissao.component.scss', '../../styles/estilo.padrao.scss']
})
export class FecharComissaoComponent implements OnInit {
  stringDataComissao: string = '';
  dateFecharComissao: Date = new Date();
  bExportar: boolean = false;
  bComissaoGerada: boolean = true;

  aVendedores: any[] = [];
  comissaoUtilizada: number = 1;
  uid;
  tipoCadastro = 'Vendedor';
  //Parâmetros setados para Todos para pegar toda a lista de pedidos, após a listagem é feita a comparação para cada vendedor
  sBuscaStatusPedido: string = 'Todos';
  sBuscaStatusPagamento: string = 'Todos';
  sBuscaIDVendedor: string = 'Todos';
  bPedidoComPendencia: boolean = false; //Se houver um pedido com pendência para ser entregue, a comissão não será fechada e haverá um alerta
  $pedidos;
  somaTotalGeral: number = 0;
  totalComissao: number = 0;
  auxPedidos: PedidoRelatorioElement[] = [];

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.dateFecharComissao.setMonth(this.dateFecharComissao.getMonth());

    this.stringDataComissao = this.usuarioService.tratarMesData(this.dateFecharComissao.getTime());

    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });
  }

  ngOnInit(): void {
    this.spinner.show('relatorio-comissao');

    this.usuarioService.getComissao(this.stringDataComissao).pipe(take(1)).subscribe(snap => {
      if (snap.length === 0) {
        //Recupera os funcionários / Vendedores
        this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
          this.aVendedores = [];

          if (snap.length > 0) {
            var dados;

            snap.forEach((item, index) => {
              dados = item.payload.val();
              if (dados.Status && dados.Permissoes.Vender) {
                this.aVendedores.push({
                  IDVendedor: item.key,
                  Nome: dados.Nome,
                  Comissao: dados.Comissao,
                  Pedidos: [],
                  SomaTotal: 0,
                  ContEntregues: 0,
                  ContCancelados: 0,
                  ContPagamentoPendente: 0,
                  ContPagamentoConfirmado: 0,
                  ContPagamentoCancelado: 0,
                  ContPagamentoBoleto: 0,
                  ContPagamentoCredito: 0,
                  ContPagamentoDebito: 0,
                  ContPagamentDinheiro: 0,
                  TotalComissao: 0,
                });
              }
            });
          }

          this.bComissaoGerada = false;
        });
      } else {
        this.toastr.error("A comissão da referência informada já foi gerada!", 'Erro');
      }

      setTimeout(() => this.spinner.hide('relatorio-comissao'), 300);
    })
  }

  fecharComissao() {

    this.spinner.show('default');
    let timestampInicio: Date = new Date(this.dateFecharComissao.getFullYear(), this.dateFecharComissao.getMonth(), 0);
    timestampInicio.setDate(1);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(this.dateFecharComissao.getFullYear(), this.dateFecharComissao.getMonth(), 0);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);

    this.somaTotalGeral = 0;

    this.$pedidos = this.usuarioService.getPedidosTimestamp(timestampInicio.getTime(), timestampFinal.getTime(), 'Período').pipe(take(1)).subscribe(snap => {
      if (snap.length > 0) {
        this.auxPedidos = [];
        var dados;
        let auxPedido: PedidoRelatorioElement;

        console.log(snap.length)

        snap.forEach((item, index) => {
          dados = item.payload.val();

          auxPedido = {
            ID: item.key,
            Bairro: dados.Bairro,
            BandeiraCartao: dados.BandeiraCartao,
            CEP: dados.CEP,
            Cidade: dados.Cidade,
            Complemento: dados.Complemento,
            Email: dados.Email,
            FormaPagamento: dados.FormaPagamento,
            NumeroParcelas: dados.NumeroParcelas,
            IDVendedor: dados.IDVendedor,
            Logradouro: dados.Logradouro,
            Nome: dados.Nome,
            Numero: dados.Numero,
            Observacao: dados.Observacao,
            Referencia: dados.Referencia,
            Status: dados.Status,
            StatusPagamento: dados.StatusPagamento,
            Telefone: dados.Telefone,
            TelefoneSecundario: dados.TelefoneSecundario,
            Total: 'R$ ' + dados.Total.toFixed(2).replace('.', ','),
            UF: dados.UF,
            Data: this.usuarioService.tratarData(dados.Timestamp),
            Hora: this.usuarioService.tratarHora(dados.Timestamp),
            DataSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarData(dados.TimestampSeparacao) : '-',
            HoraSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarHora(dados.TimestampSeparacao) : '-',
            DataRota: dados.TimestampRota ? this.usuarioService.tratarData(dados.TimestampRota) : '-',
            HoraRota: dados.TimestampRota ? this.usuarioService.tratarHora(dados.TimestampRota) : '-',
            DataEntregue: dados.TimestampEntregue ? this.usuarioService.tratarData(dados.TimestampEntregue) : '-',
            HoraEntregue: dados.TimestampEntregue ? this.usuarioService.tratarHora(dados.TimestampEntregue) : '-',
            DataCancelado: dados.TimestampCancelado ? this.usuarioService.tratarData(dados.TimestampCancelado) : '-',
            HoraCancelado: dados.TimestampCancelado ? this.usuarioService.tratarHora(dados.TimestampCancelado) : '-',
            MotivoCancelamento: dados.MotivoCancelamento ? dados.MotivoCancelamento : '-',
            DataHoraPagamento: dados.TimestampPagamento ? this.usuarioService.tratarDataHora(dados.TimestampPagamento) : '-',
            Plataforma: dados.Plataforma,
            IDDispositivo: dados.IDDispositivo ? dados.IDDispositivo : '-',
            Dispositivo: dados.Dispositivo
          };

          this.auxPedidos.push(auxPedido);

          const auxIndexVendedor = this.aVendedores.findIndex(x => x.IDVendedor === dados.IDVendedor);

          if (auxIndexVendedor !== -1) {
            if (dados.Status === 'Entregue' || dados.Status === 'Cancelado') {
              this.comissaoUtilizada = this.aVendedores[auxIndexVendedor].Comissao;

              dados.Status === 'Entregue' ? this.somaTotalGeral += dados.Total : null;

              dados.Status === 'Entregue' ? this.aVendedores[auxIndexVendedor].SomaTotal += dados.Total : null;
              dados.Status === 'Entregue' ? this.aVendedores[auxIndexVendedor].TotalComissao += (dados.Total * (0.01 * this.comissaoUtilizada)) : null;

              dados.Status === 'Entregue' ? this.aVendedores[auxIndexVendedor].ContEntregues++ : null;
              dados.Status === 'Cancelado' ? this.aVendedores[auxIndexVendedor].ContCancelados++ : null;
              dados.StatusPagamento === 'Pendente' ? this.aVendedores[auxIndexVendedor].ContPagamentoPendente++ : null;
              dados.StatusPagamento === 'Pago' ? this.aVendedores[auxIndexVendedor].ContPagamentoConfirmado++ : null;
              dados.StatusPagamento === 'Cancelado' ? this.aVendedores[auxIndexVendedor].ContPagamentoCancelado++ : null;
              dados.FormaPagamento === 'Boleto' ? this.aVendedores[auxIndexVendedor].ContPagamentoBoleto++ : null;
              dados.FormaPagamento === 'Cartão de crédito' ? this.aVendedores[auxIndexVendedor].ContPagamentoCredito++ : null;
              dados.FormaPagamento === 'Cartão de débito' ? this.aVendedores[auxIndexVendedor].ContPagamentoDebito++ : null;
              dados.FormaPagamento === 'Dinheiro' ? this.aVendedores[auxIndexVendedor].ContPagamentDinheiro++ : null;
              this.aVendedores[auxIndexVendedor].Pedidos.push(auxPedido);
            } else {
              this.bPedidoComPendencia = true;
            }
          }
        });

        this.usuarioService.setLog("Fechamento de comissão. Período: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);

        if (!this.bPedidoComPendencia) {
          let mapVendedores = {};
          for (let i = 0; i < this.aVendedores.length; i++) {
            mapVendedores[this.aVendedores[i].IDVendedor] = {
              Nome: this.aVendedores[i].Nome,
              Comissao: this.aVendedores[i].Comissao,
              SomaTotal: this.aVendedores[i].SomaTotal,
              ContEntregues: this.aVendedores[i].ContEntregues,
              ContCancelados: this.aVendedores[i].ContCancelados,
              ContPagamentoBoleto: this.aVendedores[i].ContPagamentoBoleto,
              ContPagamentoCredito: this.aVendedores[i].ContPagamentoCredito,
              ContPagamentoDebito: this.aVendedores[i].ContPagamentoDebito,
              ContPagamentDinheiro: this.aVendedores[i].ContPagamentDinheiro,
              TotalComissao: this.aVendedores[i].TotalComissao,
              TimestampInicio: timestampInicio.getTime(),
              TimestampFinal: timestampFinal.getTime(),
              IDVendedor_TimestampInicio: this.aVendedores[i].IDVendedor + '_' + timestampInicio.getTime(),
              IDVendedor_TimestampFinal: this.aVendedores[i].IDVendedor + '_' + timestampFinal.getTime()
            }
          };

          const map = {
            TimestampInicio: timestampInicio.getTime(),
            TimestampFinal: timestampFinal.getTime(),
            MapVendedores: mapVendedores,
            Periodo: this.stringDataComissao,
          };

          this.usuarioService.setComissao(this.uid, map).then(resp => {
            setTimeout(() => this.spinner.hide('default'), 300);

            if (resp) {
              this.bExportar = true;
            } else {
              this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                this.router.navigate(["/pages/fechar-comissao"]));
            }
          });

        } else {
          this.toastr.error('Não é possível fechar a comissão do mês com pedidos pendentes para confirmar entrega', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          this.usuarioService.setLog("Falha ao fechar comissão. Há pedidos pendente. Período: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);
          setTimeout(() => this.spinner.hide('default'), 300);
        }

      } else {
        this.toastr.error("Não foi possível localizar pedidos!", 'Erro');
        setTimeout(() => this.spinner.hide('default'), 300);
      }
    });
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: false, bCSV: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    let date: Date = new Date(this.dateFecharComissao.getFullYear(), this.dateFecharComissao.getMonth() + 1, 0);
    date.setDate(1);

    let dateFinal: Date = new Date(this.dateFecharComissao.getFullYear(), this.dateFecharComissao.getMonth() + 1, 0);

    switch (tipo) {
      //PDF
      case 0:
        let doc: any = new jsPDF('l', 'mm', [297, 210]);

        for (let i = 0; i < this.aVendedores.length; i++) {
          const map = {
            Soma: this.aVendedores[i].SomaTotal,
            ContEntregues: this.aVendedores[i].ContEntregues,
            ContCancelados: this.aVendedores[i].ContCancelados,
            ContPagmentoBoleto: this.aVendedores[i].ContPagamentoBoleto,
            ContPagamentoCredito: this.aVendedores[i].ContPagamentoCredito,
            ContPagamentoDebito: this.aVendedores[i].ContPagamentoDebito,
            ContPagamentoDinheiro: this.aVendedores[i].ContPagamentDinheiro,
            Periodo: this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime())
          }

          let corpo: any = [];
          this.auxPedidos.forEach(dado => {
            if ((dado.Status === 'Entregue' && dado.IDVendedor === this.aVendedores[i].IDVendedor) || (dado.Status === 'Cancelado' && dado.IDVendedor === this.aVendedores[i].IDVendedor)) {
              var aux = [dado.ID, dado.Data, dado.Bairro, dado.Cidade, dado.Nome, dado.FormaPagamento, dado.StatusPagamento, dado.Status, dado.DataEntregue, dado.Total];
              corpo.push(aux);
            }
          });

          let finalY = doc.lastAutoTable.finalY ? (doc.lastAutoTable.finalY + 15) : 15;
          doc.text(this.aVendedores[i].Nome, 14, finalY)

          autoTable(doc, {
            head: [["Pedido", "Data", "Bairro", "Cidade", "Cliente", "Forma de PGT", "Status PGT", "Status", "Data da entrega", "Total"]],
            theme: 'grid',
            body: corpo,
            margin: { top: 10, right: 5, bottom: 10, left: 5 },
            showHead: 'firstPage',
            showFoot: 'lastPage',
            foot: [["", "", "", "", "", "", "", "Comissão: " + this.aVendedores[i].Comissao + "%", "Comissão: R$ " + this.aVendedores[i].TotalComissao.toFixed(2).replace('.', ','), "Total: R$ " + this.aVendedores[i].SomaTotal.toFixed(2).replace('.', ',')]],
            startY: finalY + 3
          });
        }

        doc.save('Relatório_Comissão_Vendedores_Geral ' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()) + '.pdf');

        this.usuarioService.setLog('Exportou Relatório_Comissão_Vendedores_Geral ' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), null, this.uid);
        break;
    }
  }
}
